import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { ExtendedProjectInfoDc } from "@evergis/api";

import { project } from "../../resources/projects";
import { setProject } from "../../ducks/project/project";

type UseSharedServiceReturnType = {
  sharedProject: ExtendedProjectInfoDc;
  error: Error;
  loading: boolean;
};

export const useSharedService = (name: string): UseSharedServiceReturnType => {
  const dispatch = useDispatch();
  const { data, error, loading } = project.use({ input: name, waitInput: true });

  useEffect(() => {
    const value = getSharedProjectSafe(data as ExtendedProjectInfoDc);

    if (data) {
      dispatch(setProject(value));
    }
  }, [data]);

  const sharedProject = useMemo(() => getSharedProjectSafe(data as ExtendedProjectInfoDc), [data]);

  return useMemo(
    () => ({
      sharedProject,
      error,
      loading,
    }),
    [sharedProject, error, loading],
  );
};

function getSharedProjectSafe(sharedProject = {} as ExtendedProjectInfoDc): ExtendedProjectInfoDc {
  return {
    alias: "",
    name: "",
    owner: "",
    ...sharedProject,
    content: {
      position: null,
      resolution: null,
      ...sharedProject.content,
    },
  };
}
